export const DS_OPTION_LABEL_CLASSES = {
  Root: "ds-option-label",
  Label: "ds-option-label__label",
  Content: "ds-option-label__content",
  Text: "ds-option-label__text",
  Description: "ds-option-label__description",
  Input: "ds-option-label__input",
  Vertical: "ds-option-label--vertical",
  Horizontal: "ds-option-label--horizontal",
  WithIcon: "ds-option-label--with-icon",
  WithColor: "ds-option-label--with-color",
  Tile: "ds-option-label--tile",
  Selected: "ds-option-label--selected",
  Null: "ds-option-label--null",
};
